import { StateCreator } from 'zustand'
import { SharedSlice } from '../../../../slice'

interface PayClassificationsState {
  showDeactivated: boolean
}

export interface PayClassificationsSlice extends PayClassificationsState {
  setShowDeactivated: () => void

  /**
   * Resets PayClassifications Slice state
   */
  resetPayClassificationsSlice: () => void
}

const initialState: PayClassificationsState = {
  showDeactivated: false,
}

const createPayClassificationsSlice: StateCreator<
  PayClassificationsSlice & SharedSlice,
  [],
  [],
  PayClassificationsSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  setShowDeactivated: () =>
    set((state) => ({ showDeactivated: !state.showDeactivated })),
  resetPayClassificationsSlice: () => set(initialState),
})

export default createPayClassificationsSlice
